export default __webpack_public_path__ + "static/banner2_mobile-fce4b5f3a727a3b53c36b58471377d7d.png";